import * as Moment from 'moment';
import { extendMoment } from 'moment-range';

export const moment = extendMoment(Moment);
